import {InteractionType} from '@azure/msal-browser';
import {MsalProvider, useMsalAuthentication} from '@azure/msal-react';
import {CheckCircleOutline, ErrorOutline, HighlightOff} from '@mui/icons-material';
import {CssBaseline, ThemeProvider} from '@mui/material';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {LicenseInfo} from '@mui/x-license-pro';
import {devTools} from '@ngneat/elf-devtools';
import {SnackbarProvider} from 'notistack';
import {BrowserRouter} from 'react-router-dom';

import {msalInstance} from '@config/azure.config';

import {SnackbarUtilsConfigurator} from '@utils/snackbar.utils';

import Routes from '@screens/index';

import {PopupServiceProvider} from '@components/modal/popup/PopupService';
import {Colors} from '@constants/colors.constants';
import theme from '@theme/index';

LicenseInfo.setLicenseKey('197d9019a7696ef29dd0ce760ce4aeb7Tz05NjY5NSxFPTE3NTU5MzUwMjEwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLFBWPWluaXRpYWwsS1Y9Mg==');

if (devTools) {
  devTools();
}


const App = () => {
  useMsalAuthentication(InteractionType.Redirect);

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
        <PopupServiceProvider>
          <SnackbarProvider
            style={{backgroundColor: Colors.text}}
            maxSnack={3}
            autoHideDuration={3000}
            iconVariant={{
              success: <CheckCircleOutline color="primary" style={{marginRight: 10}}/>,
              error: <HighlightOff color="error" style={{marginRight: 10}}/>,
              info: <ErrorOutline color="warning" style={{marginRight: 10}}/>,
            }}
            anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
            <SnackbarUtilsConfigurator/>
            <CssBaseline/>
            <MsalProvider instance={msalInstance}>
              <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Routes/>
              </BrowserRouter>
            </MsalProvider>
          </SnackbarProvider>
        </PopupServiceProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default App;
